// B2 - Ünite 1: Present Perfect
// Hedef: Have/Has + past participle, ever, never, for, since

export const B2_UNIT_1 = {
  'B2-U1-L1': {
    id: 'B2-U1-L1',
    title: 'Have/Has + Past Participle',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Perfect Tense',
          explanation: 'Present Perfect geçmişte başlayıp şu ana kadar etkisi devam eden eylemler için kullanılır. Have/Has + V3 (past participle)',
          table: {
            headers: ['Şahıs', 'Yapı', 'Örnek'],
            rows: [
              ['I/You/We/They', 'have + V3', 'I have worked as cabin crew.'],
              ['He/She/It', 'has + V3', 'She has flown to 50 countries.'],
              ['Olumsuz', 'have/has not + V3', 'I have not (haven\'t) been to Japan.'],
              ['Soru', 'Have/Has + subject + V3?', 'Have you ever been to Paris?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['I have worked in aviation for 5 years.', '5 yıldır havacılıkta çalışıyorum.'],
              ['She has completed her safety training.', 'Güvenlik eğitimini tamamladı.'],
              ['We have served thousands of passengers.', 'Binlerce yolcuya hizmet ettik.'],
              ['The flight has been delayed.', 'Uçuş ertelendi.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 V3 (Past Participle): work→worked, go→gone, fly→flown, be→been, see→seen'
        },
        {
          type: 'vocabulary',
          title: '📝 Düzensiz Fiiller (V3)',
          words: [
            { en: 'go → gone', tr: 'gitmek → gitmiş', pronunciation: '' },
            { en: 'fly → flown', tr: 'uçmak → uçmuş', pronunciation: '' },
            { en: 'be → been', tr: 'olmak → olmuş', pronunciation: '' },
            { en: 'see → seen', tr: 'görmek → görmüş', pronunciation: '' },
            { en: 'do → done', tr: 'yapmak → yapmış', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ in aviation for 5 years.',
          options: ['have worked', 'has worked', 'worked', 'am working'],
          correct: 'have worked',
          explanation: 'I + have + V3'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ her training.',
          options: ['has completed', 'have completed', 'completed', 'is completing'],
          correct: 'has completed',
          explanation: 'She + has + V3'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['worked', 'have', 'I', 'airline', 'this', 'for'],
          correctOrder: [2, 1, 0, 5, 4, 3],
          translation: 'Bu havayolu için çalıştım.'
        },
        {
          type: 'flashcard',
          title: '🎴 Düzensiz Fiil Kartları',
          cards: [
            { front: 'go', back: 'gone' },
            { front: 'fly', back: 'flown' },
            { front: 'be', back: 'been' },
            { front: 'see', back: 'seen' },
            { front: 'do', back: 'done' },
            { front: 'take', back: 'taken' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ V3 Yarışı',
          cards: [
            { front: 'go', back: 'gone' },
            { front: 'fly', back: 'flown' },
            { front: 'work', back: 'worked' },
            { front: 'see', back: 'seen' },
            { front: 'be', back: 'been' },
            { front: 'have', back: 'had' }
          ]
        }
      ]
    }
  },
  'B2-U1-L2': {
    id: 'B2-U1-L2',
    title: 'Ever, Never, Already, Yet, Just',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Perfect ile Kullanılan Zarflar',
          table: {
            headers: ['Zarf', 'Anlam', 'Örnek'],
            rows: [
              ['ever', 'hiç (soruda)', 'Have you ever been to Paris?'],
              ['never', 'hiç (olumsuz)', 'I have never been late.'],
              ['already', 'zaten, çoktan', 'I have already checked the cabin.'],
              ['yet', 'henüz (soru/olumsuz)', 'Have you finished yet? / I haven\'t finished yet.'],
              ['just', 'az önce', 'The flight has just landed.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Zarf', 'Örnek', 'Türkçesi'],
            rows: [
              ['ever', 'Have you ever flown business class?', 'Hiç business class uçtunuz mu?'],
              ['never', 'I have never missed a flight.', 'Hiç uçuş kaçırmadım.'],
              ['already', 'We have already served lunch.', 'Öğle yemeğini zaten servis ettik.'],
              ['yet', 'We haven\'t landed yet.', 'Henüz inmedik.'],
              ['just', 'The captain has just made an announcement.', 'Kaptan az önce anons yaptı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Ever = soruda | Never = olumsuz (don\'t ile kullanılmaz!) | Yet = soru ve olumsuzda'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Have you _____ been to Dubai?',
          options: ['ever', 'never', 'already', 'yet'],
          correct: 'ever',
          explanation: 'Soruda: ever'
        },
        {
          type: 'multipleChoice',
          question: 'I have _____ been late to work.',
          options: ['never', 'ever', 'yet', 'already'],
          correct: 'never',
          explanation: 'Olumsuz anlam: never'
        },
        {
          type: 'multipleChoice',
          question: 'The flight has _____ landed.',
          options: ['just', 'yet', 'ever', 'never'],
          correct: 'just',
          explanation: 'Az önce: just'
        },
        {
          type: 'flashcard',
          title: '🎴 Zarf Kartları',
          cards: [
            { front: 'ever', back: 'hiç (soruda)' },
            { front: 'never', back: 'hiç (olumsuz)' },
            { front: 'already', back: 'zaten, çoktan' },
            { front: 'yet', back: 'henüz' },
            { front: 'just', back: 'az önce' }
          ]
        }
      ]
    }
  },
  'B2-U1-L3': {
    id: 'B2-U1-L3',
    title: 'For vs Since',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 For vs Since',
          explanation: 'For süre bildirir, Since başlangıç noktası bildirir.',
          table: {
            headers: ['For (Süre)', 'Since (Başlangıç)'],
            rows: [
              ['for 5 years', 'since 2019'],
              ['for 3 months', 'since January'],
              ['for 2 hours', 'since 10 AM'],
              ['for a long time', 'since I was young']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['I have worked here for 5 years.', '5 yıldır burada çalışıyorum.'],
              ['I have worked here since 2019.', '2019\'dan beri burada çalışıyorum.'],
              ['She has been a pilot for 10 years.', '10 yıldır pilot.'],
              ['She has been a pilot since 2014.', '2014\'ten beri pilot.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 FOR = süre (5 years, 3 months) | SINCE = tarih/zaman noktası (2019, January)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I have worked here _____ 2018.',
          options: ['since', 'for', 'from', 'during'],
          correct: 'since',
          explanation: '2018 = tarih → since'
        },
        {
          type: 'multipleChoice',
          question: 'I have worked here _____ 5 years.',
          options: ['for', 'since', 'from', 'during'],
          correct: 'for',
          explanation: '5 years = süre → for'
        },
        {
          type: 'timeRace',
          title: '⏱️ For mu Since mi?',
          cards: [
            { front: '5 years', back: 'for' },
            { front: '2020', back: 'since' },
            { front: '3 months', back: 'for' },
            { front: 'January', back: 'since' },
            { front: '2 hours', back: 'for' },
            { front: 'last week', back: 'since' },
            { front: 'a long time', back: 'for' },
            { front: 'Monday', back: 'since' }
          ]
        }
      ]
    }
  },
  'B2-U1-L4': {
    id: 'B2-U1-L4',
    title: 'Present Perfect vs Past Simple',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Perfect vs Past Simple',
          table: {
            headers: ['Present Perfect', 'Past Simple'],
            rows: [
              ['Geçmiş → Şu an bağlantılı', 'Geçmişte bitti'],
              ['Zaman belirsiz', 'Zaman belirli'],
              ['I have visited Paris.', 'I visited Paris last year.'],
              ['She has worked here for 5 years.', 'She worked here in 2019.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Karşılaştırma',
          table: {
            headers: ['Durum', 'Present Perfect', 'Past Simple'],
            rows: [
              ['Deneyim (ne zaman belirsiz)', 'I have flown to Dubai.', '-'],
              ['Belirli zaman', '-', 'I flew to Dubai last month.'],
              ['Devam eden', 'I have worked here for 5 years.', '-'],
              ['Biten', '-', 'I worked there from 2015 to 2018.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 yesterday, last week, in 2019 = Past Simple | ever, never, already, just = Present Perfect'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ to Paris last summer.',
          options: ['went', 'have gone', 'have been', 'go'],
          correct: 'went',
          explanation: 'last summer = belirli zaman → Past Simple'
        },
        {
          type: 'multipleChoice',
          question: 'I _____ to Paris. It\'s beautiful!',
          options: ['have been', 'went', 'was', 'go'],
          correct: 'have been',
          explanation: 'Ne zaman belirsiz, şu anla bağlantılı → Present Perfect'
        },
        {
          type: 'flashcard',
          title: '🎴 Zaman İfadeleri',
          cards: [
            { front: 'yesterday', back: 'Past Simple' },
            { front: 'ever', back: 'Present Perfect' },
            { front: 'last week', back: 'Past Simple' },
            { front: 'already', back: 'Present Perfect' },
            { front: 'in 2019', back: 'Past Simple' },
            { front: 'just', back: 'Present Perfect' }
          ]
        }
      ]
    }
  },
  'B2-U1-L5': {
    id: 'B2-U1-L5',
    title: 'Uygulama: Deneyim Anlatma',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '🎤 Mülakata Present Perfect',
          table: {
            headers: ['Soru', 'Cevap'],
            rows: [
              ['Have you ever worked in aviation?', 'Yes, I have worked in aviation for 3 years.'],
              ['Have you ever dealt with difficult customers?', 'Yes, I have dealt with many challenging situations.'],
              ['How long have you worked in customer service?', 'I have worked in customer service since 2020.'],
              ['What experience have you had?', 'I have had experience in hospitality and retail.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '📝 Mülakat Cümleleri',
          words: [
            { en: 'I have worked in customer service for 5 years.', tr: '5 yıldır müşteri hizmetlerinde çalışıyorum.', pronunciation: '' },
            { en: 'I have never missed a deadline.', tr: 'Hiç son teslim tarihini kaçırmadım.', pronunciation: '' },
            { en: 'I have already completed my training.', tr: 'Eğitimimi zaten tamamladım.', pronunciation: '' },
            { en: 'I have dealt with many difficult situations.', tr: 'Birçok zor durumla ilgilendim.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Mülakata "I have experience in..." ile başlayın. Deneyimlerinizi Present Perfect ile anlatın!'
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu cümleleri sesli okuyun:',
          phrases: [
            'I have worked in customer service for 3 years.',
            'I have dealt with many challenging situations.',
            'I have never been late to work.',
            'I have already completed my safety training.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'I _____ (work) in hospitality since 2019.',
          answer: 'have worked',
          hint: 'Present Perfect: have + V3'
        }
      ]
    }
  },
  'B2-U1-EXAM': {
    id: 'B2-U1-EXAM',
    title: 'Ünite 1 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'I _____ in aviation for 5 years.',
        options: ['have worked', 'has worked', 'worked', 'working'],
        correct: 'have worked',
        explanation: 'I + have + V3'
      },
      {
        type: 'multipleChoice',
        question: 'Have you _____ been to London?',
        options: ['ever', 'never', 'already', 'yet'],
        correct: 'ever',
        explanation: 'Soruda: ever'
      },
      {
        type: 'multipleChoice',
        question: 'I have worked here _____ 2018.',
        options: ['since', 'for', 'from', 'during'],
        correct: 'since',
        explanation: 'Tarih: since'
      },
      {
        type: 'multipleChoice',
        question: 'I have worked here _____ 5 years.',
        options: ['for', 'since', 'from', 'during'],
        correct: 'for',
        explanation: 'Süre: for'
      },
      {
        type: 'multipleChoice',
        question: 'I _____ to Paris last year.',
        options: ['went', 'have gone', 'have been', 'go'],
        correct: 'went',
        explanation: 'last year = Past Simple'
      },
      {
        type: 'fillInBlank',
        sentence: 'She has _____ (complete) her training.',
        answer: 'completed',
        hint: 'V3: complete → completed'
      },
      {
        type: 'matchPairs',
        instruction: 'For vs Since eşleştirin',
        pairs: [
          { left: '5 years', right: 'for' },
          { left: '2020', right: 'since' },
          { left: '3 months', right: 'for' },
          { left: 'January', right: 'since' }
        ]
      }
    ]
  }
};

export default B2_UNIT_1;
